// import {combineReducers} from 'redux';
import authReducer from './auth/authSlice';
import configReducer from './config/configSlice';
import documentReducer from './documents/documentSlice';
import templateReducer from './template/templateSlice';
import listReducer from './listing/listingSlice';
import bannerReducer from './banner/bannerSlice';
import resourceReducer from './resource/resourceSlice';
import downloadTemplateReducer from './bulk/downloadTemplateSlice'
import newsFeedReducer from './news/newsSlice'
import tenantReducer from './tenant/tenantSlice';
import loderReducer from './loader/loaderSlice';
import chartReducer from './charts/chartSlice';
import gaiReducer from './gai/gaiSlice';

export const rootReducer = {
   auth: authReducer,
   document: documentReducer,
   template: templateReducer,
   config: configReducer,
   list: listReducer,
   banner: bannerReducer,
   resource : resourceReducer,
   bulkUpload : downloadTemplateReducer,
   newsFeed: newsFeedReducer,
   tenant: tenantReducer,
   loader: loderReducer,
   chart: chartReducer,
   gai : gaiReducer
};